import { render, staticRenderFns } from "./PillBadgeNotification.vue?vue&type=template&id=88722caa&"
import script from "./PillBadgeNotification.vue?vue&type=script&lang=js&"
export * from "./PillBadgeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports